import React from 'react'
import styled from 'styled-components'
import { Popover } from 'antd'
import format from 'date-fns/format'

const Container = styled('div')`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	padding: 0 8px;
	overflow: hidden;
	line-height: 14px;
	background: rgba(80, 80, 80, 0.8);
	border-top: 1px solid rgba(249, 249, 249, 1) !important;
	border-radius: 4px;
	pointer-events: auto;
	cursor: pointer;

	background-image: linear-gradient(
		45deg,
		rgba(69, 69, 74, 1) 25%,
		rgba(80, 80, 80, 1) 25%,
		rgba(80, 80, 80, 1) 50%,
		rgba(69, 69, 74, 1) 50%,
		rgba(69, 69, 74, 1) 75%,
		rgba(80, 80, 80, 1) 75%,
		rgba(80, 80, 80, 1) 100%
	);

	background-size: 12px 12px;

	.name {
		font-weight: 700;
		font-size: 14px;
		white-space: nowrap;
	}

	.time {
		font-size: 12px;
		white-space: nowrap;
		text-align: right;
	}
`

const BlockedTimeEvent = ({ event }) => {
	return (
		<Popover
			content={
				<div style={{ maxWidth: 300, textAlign: 'center' }}>
					<h3>Blocked Time</h3>
					{event.description && <p>{event.description}</p>}
					<div>
						{format(event.start || event.startTime, 'h:mm A')} -{' '}
						{format(event.end || event.endTime, 'h:mm A')}
					</div>
				</div>
			}
		>
			<Container>
				<div className="name">Blocked Time</div>

				<div className="time">
					{format(event.start || event.startTime, 'h:mm A')} -{' '}
					{format(event.end || event.endTime, 'h:mm A')}
				</div>
			</Container>
		</Popover>
	)
}

export default BlockedTimeEvent
